import React from 'react';
import ReactDOM from 'react-dom';
import CandyCartApp from '../../CandyCartApp';
import { handleDiscounts } from '../../shared/utils/discounts';
import cleanupCartData from '../../utils/cart-cleanup';
import captureException from '../../utils/sentry';
import { logError, logInfo } from '../../shared/utils/logging';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import Buttons from './buttons';

export default function init(
  isDefaultInit: boolean = true,
  storefrontAccessToken: string,
) {
  try {
    logInfo('loaded 🎉', REGISTERED_APPS.CANDYCART);
    const buttons: Buttons = new Buttons('checkoutButtonClicked');

    document.body.insertAdjacentHTML(
      'beforeend',
      '<div id="candycart-root"></div>',
    );

    ReactDOM.render(
      <CandyCartApp
        buttons={buttons}
        storefrontAccessToken={storefrontAccessToken}
      />,
      document.getElementById('candycart-root'),
    );
    // Clean up should only happen on new load
    if (isDefaultInit) {
      handleDiscounts(REGISTERED_APPS.CANDYCART);
      cleanupCartData(REGISTERED_APPS.CANDYCART);
    }
  } catch (error) {
    logError(error);
    captureException(error as Error);
  }
}
